import { gql } from '@apollo/client';

export const GET_INDICATOR_FRAMEWORKS = gql`
  query GetIndicatorFrameworks($input: IndicatorWorkspaceInput) {
    indicatorFrameworks: getIndicatorWorkspaces(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          name
          reportersCount
          intervention {
            id
            name
          }
          programme {
            id
            name
          }
          frameworkType {
            id
            name
          }
        }
      }
    }
  }
`;
